import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { BareInput } from "./BareInput";
import { isEmail } from "../validator";
import { inputTypes } from "../types";
import { InputPropTypes } from "../propTypes";

/** A primitive input with email validation. */
import { jsx as ___EmotionJSX } from "@emotion/core";
const BareEmailInput = props => ___EmotionJSX(BareInput, props);
BareEmailInput.validate = isEmail;
BareEmailInput.inputType = inputTypes.email;
BareEmailInput.propTypes = _extends({}, InputPropTypes.propTypes);
BareEmailInput.defaultProps = {
  value: ''
};
export { BareEmailInput };